import {BBElement} from '../../forms/elements/BBElement';
import {RenderProfileInterface} from './RenderProfileInterface';

export class PhotosRender implements RenderProfileInterface {

    isPhoto: boolean;

    constructor(isPhoto: boolean) {
        this.isPhoto = isPhoto;
    }

    public render(profileElements: HTMLCollectionOf<HTMLElement>): void {
        if (!profileElements.length) {
            return;
        }
        for (let i = 0; i < profileElements.length; i++) {
            this.renderPhoto(this.isPhoto, profileElements[i]);
        }
    }

    /*
     * Подкинем заглушку если фото нет
     */
    public renderPhoto(isPhoto: boolean, widget: Element): void {
        if (isPhoto) {
            let photo = new BBElement(widget.querySelector('.photo'));
            photo.addClass('noloadbar');
        } else {
            let widgetProfile = new BBElement(widget as HTMLElement);
            widgetProfile.addClass('noPhoto');
        }
    }
}